import { useTranslation } from 'react-i18next';

import { useResponsive } from '@actual-app/components/hooks/useResponsive';

import { MobilePageHeader, PageHeader } from '#components/Page';

/**
 * `Page` only applies its header styling when the header is a plain string; a
 * translated element is rendered raw. On narrow screens that left the title
 * unstyled inside the purple header bar, and on desktop it was small unstyled
 * text. Render the standard mobile or desktop page header instead.
 */
export function DashboardPageHeader() {
  const { t } = useTranslation();
  const { isNarrowWidth } = useResponsive();

  return isNarrowWidth ? (
    <MobilePageHeader title={t('My money')} />
  ) : (
    <PageHeader title={t('My money')} />
  );
}
